import { useEffect, useRef } from 'react';
import Lenis from 'lenis';
import { useLocation } from 'react-router-dom';

const LANDING_PAGES = ['/home', '/tenant-home', '/details'];

const useSmoothScroll = (contentAreaElement: HTMLDivElement | null) => {
    const lenisRef = useRef<Lenis | null>(null);
    const location = useLocation();

    const isLandingPage = LANDING_PAGES.includes(location.pathname) ||
        (location.pathname.includes('/articles') && !location.pathname.includes('/knowledge-hub'));

    useEffect(() => {
        if (!isLandingPage || !contentAreaElement) {
            // Destroy existing instance when navigating away from landing pages
            if (lenisRef.current) {
                lenisRef.current.destroy();
                lenisRef.current = null;
            }
            return;
        }

        const lenis = new Lenis({
            wrapper: contentAreaElement,
            content: contentAreaElement.firstElementChild as HTMLElement || contentAreaElement,
            lerp: 0.1,
            smoothWheel: true,
            touchMultiplier: 1.5,
        });

        lenisRef.current = lenis;

        let rafId: number;
        const raf = (time: number) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, [isLandingPage, contentAreaElement]);

    return lenisRef;
};

export default useSmoothScroll;
